/*
 * @providesModule ReferralInsufficientFunds
 * 
 */


import React from 'react';

import AWSManager from 'AWSManager';
import GlobalEventEmitter from 'GlobalEventEmitter';
import HeaderModal from 'HeaderModal';
import HTMLText from 'HTMLText';
import Label from 'Label';
import {_m} from 'INTL';
import ModalNavigationController from 'ModalNavigationController';
import PropTypes from 'prop-types';
import PushButton from 'PushButton';
import SkillzSDK from 'SkillzSDK';
import SkillzStyle from 'SkillzStyle';
import styles from 'ReferralInsufficientFundsStyle';

import {
  View,
} from 'react-native';

const {
  btnGradientOne,
  btnGradientTwo,
  viewCornerRadiusSecondary,
} = SkillzStyle.fullStyles;

export default class ReferralInsufficientFunds extends React.Component {

  static propTypes = {
    promoCode: PropTypes.string.isRequired,
  };

  _onBackPress = () => {
    ModalNavigationController.hideModal();
  }

  _onNextPress = () => {
    AWSManager.trackEvent('LIVE_EVENTS_CREATION_INSUFFICIENT_NEXT');
    ModalNavigationController.hideModal();
    SkillzSDK.popNavigatorToRoot();
    GlobalEventEmitter.emit('redeemPromoCode', this.props.promoCode);
  }

  _renderInformation(): React.ReactElement {
    return (
      <View style={styles.infoContainer}>
        <HTMLText style={styles.infoText}
                  containerStyle={styles.infoText}
                  html={_m('Use the promo code <b>{0}</b> for additional bonus cash on your deposit!', this.props.promoCode)}/>
        <Label style={styles.validText}>
          {_m('*This offer may not be valid for all deposits')}
        </Label>
      </View>
    );
  }

  _renderButtons(): React.ReactElement {
    return (
      <View style={styles.buttonContainer}>
        <PushButton style={styles.backButton}
                    onPress={this._onBackPress}
                    colors={btnGradientTwo}
                    title={_m('BACK')}
                    textStyle={styles.backButtonText}
                    cornerRadius={viewCornerRadiusSecondary.borderRadius}/>
        <PushButton style={styles.nextButton}
                    onPress={this._onNextPress}
                    colors={btnGradientOne}
                    title={_m('NEXT')}
                    textStyle={styles.nextButtonText}
                    cornerRadius={viewCornerRadiusSecondary.borderRadius}/>
      </View>
    );
  }

  render(): React.ReactElement {
    return (
      <HeaderModal title={_m('INSUFFICIENT FUNDS')}
                  onDone={this._onBackPress}>
        <View style={styles.outerContainer}>
          {this._renderInformation()}
          {this._renderButtons()}
        </View>
      </HeaderModal>
    );
  }
}
